import { isTerminal } from "@/shared/api/hooks";
import { useI18n } from "@/shared/i18n";

interface Props {
  status: string;
}

/** created → paid flow; failed/closed render the second step as failed. */
export function OrderTimeline({ status }: Props) {
  const { t } = useI18n();
  const paid = status === "paid";
  const failed = status === "failed" || status === "closed";
  const polling = !isTerminal(status);

  const secondClass = paid
    ? "tl-step--done"
    : failed
      ? "tl-step--failed"
      : polling
        ? "tl-step--active"
        : "";

  return (
    <div className="timeline">
      <div className="tl-step tl-step--done">
        <span className="tl-dot" />
        <span className="tl-label">{t("Created")}</span>
      </div>
      <div className={`tl-line ${paid ? "tl-line--done" : ""}`} />
      <div className={`tl-step ${secondClass}`}>
        <span className="tl-dot" />
        <span className="tl-label">
          {paid ? t("Paid") : failed ? t("Closed") : t("Awaiting payment")}
        </span>
      </div>
    </div>
  );
}
